module.exports = __webpack_public_path__ + "static/media/将棋部.5e2232de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/将棋部.png
// module id = 319
// module chunks = 10